module.exports = __webpack_public_path__ + "img/offline-ship.224a1414.svg";